// #region Imports

/* Telestream */
import { SET_SNACK } from '@/utils/mutation-types';

// #endregion Imports

export const LEVELS = {
  INFO:    'info',
  ERROR:   'error',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export function sendEphemeralSnack(context, level, message) {
  context.commit(SET_SNACK, {
    message: message,
    level:   level,
  });
}

export function sendVideoLoadedSnack(videoPath, audioPaths, context) {
  let message = `Loaded ${videoPath}.`;
  if (audioPaths && audioPaths.length > 0) {
    message = `Loaded ${videoPath} with audio from ${audioPaths.join(', ')}.`;
  }

  sendEphemeralSnack(context, 'success', message);
}
